import { AnyAction } from "redux";
import { Dispatch } from "react";
import { AnalyticsType } from "../../../../interfaces";
import { getAnalytics } from "../../../analytics";

export const FETCH_DATA_ANALYTICS_REQUEST = 'FETCH_DATA_ANALYTICS_REQUEST';
export const FETCH_DATA_ANALYTICS_SUCCESS = 'FETCH_DATA_ANALYTICS_SUCCESS';
export const FETCH_DATA_ANALYTICS_FAILURE = 'FETCH_DATA_ANALYTICS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDataAnalyticsRequest = () => {
    return {
        type: FETCH_DATA_ANALYTICS_REQUEST,
    };
};

const fetchDataAnalyticsSuccess = (data: any): ActionPagination<AnalyticsType> => {
    return {
        type: FETCH_DATA_ANALYTICS_SUCCESS,
        payload: data
    };
};

const fetchDataAnalyticsFailure = (error: any) => {
    return {
        type: FETCH_DATA_ANALYTICS_FAILURE,
        payload: error,
    };
};

export const analytics = (query:any) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataAnalyticsRequest());
        try {
            const response = await getAnalytics('connection_request', query);
            dispatch(fetchDataAnalyticsSuccess(response));
        } catch (error: any) {
            dispatch(fetchDataAnalyticsFailure(error.message));
        }
    };
};
